import classNames from 'classnames'
import Header from 'components/headers/bulletins'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Switch from 'react-switch'
import useGetTransparency from '../memberTransparency/hooks/useGetTransparency'
import useSetSms from './hooks/useSetSms'
import BuyPlanModal from 'components/modals/BuyPlan'
export default function MemberSMS() {
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
    const { state } = useLocation()
    const { data, isLoading, refetch } = useGetTransparency()
    // Weekly until the fund says otherwise -- the same default the column has,
    // so a fund saved before this setting existed reads as what it actually is.
    const [digestInterval, setDigestInterval] = useState<LoanDigestInterval>(
        data?.announcement_setting.loan_digest_interval ?? 'wkl'
    )
    const [checked, setChecked] = useState<{ [key: string]: boolean }>({
        sendMessageLoanToOthers: data
            ? data.announcement_setting.sms_others_define_loan
            : false,
        sendMessageRememberMemberShip: data
            ? data.announcement_setting.sms_pay_portion_reminder
            : false,
        sendMessageRememberLoan: data
            ? data.announcement_setting.sms_pay_installment_reminder
            : false,
        sendMessageDepositToManager: data
            ? data.announcement_setting.sms_inform_managers_of_cashins
            : false,
        sendPushNotificationToOthers: data
            ? data.announcement_setting.message_others_loan
            : false,
        sendPushNotificationToAllMembers: data
            ? data.announcement_setting.notif_others_loan
            : false,
    })
    useEffect(() => {
        setChecked({
            sendMessageLoanToOthers: data
                ? data.announcement_setting.sms_others_define_loan
                : false,
            sendMessageRememberMemberShip: data
                ? data.announcement_setting.sms_pay_portion_reminder
                : false,
            sendMessageRememberLoan: data
                ? data.announcement_setting.sms_pay_installment_reminder
                : false,
            sendMessageDepositToManager: data
                ? data.announcement_setting.sms_inform_managers_of_cashins
                : false,
            sendPushNotificationToOthers: data
                ? data.announcement_setting.message_others_loan
                : false,
            sendPushNotificationToAllMembers: data
                ? data.announcement_setting.notif_others_loan
                : false,
        })
        setDigestInterval(
            data?.announcement_setting.loan_digest_interval ?? 'wkl'
        )
    }, [data])

    const navigate = useNavigate()
    const handleChangeChecked = (value: string) => {
        const newChecked = { ...checked }
        newChecked[value] = !newChecked[value]
        setChecked(newChecked)
    }
    const { id } = useParams()
    const { mutate } = useSetSms(refetch)

    return (
        <div className="  flex flex-col bg-white h-full">
            <div className=" grow-0">
                <Header title="تنظیمات صندوق" />
            </div>
            <div className=" grow px-2">
                <p className=" text-lg my-2">شفافیت ارسال اعلان های صندوق</p>
                <hr className=" my-3" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        ارسال پیامک اعطای وام به تمامی اعضا
                    </p>
                    <Switch
                        onChange={() => {
                            if (state.service_package === 2) {
                                setIsOpenModal(true)
                            } else {
                                handleChangeChecked('sendMessageLoanToOthers')
                            }
                        }}
                        checked={checked.sendMessageLoanToOthers}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، در صورت اعطای وام، پیامکی برای تمامی
                    اعضای صندوق ارسال می شود که مبلغ وام و نام وام گیرنده را
                    شامل می شود.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        ارسال پیامک یادآوری پرداخت حق عضویت
                    </p>
                    <Switch
                        onChange={() => {
                            if (state.service_package === 2) {
                                setIsOpenModal(true)
                            } else {
                                handleChangeChecked(
                                    'sendMessageRememberMemberShip'
                                )
                            }
                        }}
                        checked={checked.sendMessageRememberMemberShip}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضوی که تا سه روز پیش از سررسید
                    صندوق، حق عضویت خود را پرداخت نکرده، پیامک یادآوری دریافت
                    خواهد کرد.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        ارسال پیامک یادآوری پرداخت قسط وام
                    </p>
                    <Switch
                        onChange={() => {
                            if (state.service_package === 2) {
                                setIsOpenModal(true)
                            } else {
                                handleChangeChecked('sendMessageRememberLoan')
                            }
                        }}
                        checked={checked.sendMessageRememberLoan}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضوی که تا سه روز پیش از موعد قسطش،
                    قسط خود را پرداخت نکرده، پیامک یادآوری دریافت خواهد کرد.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">ارسال پیامک واریزی به مدیر</p>
                    <Switch
                        onChange={() => {
                            if (state.service_package === 2) {
                                setIsOpenModal(true)
                            } else {
                                handleChangeChecked(
                                    'sendMessageDepositToManager'
                                )
                            }
                        }}
                        checked={checked.sendMessageDepositToManager}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، هرگاه هر یک از اعضا، واریز وجه داشته
                    باشد، پیامک اطلاع رسانی برای مدیران صندوق ارسال خواهد شد.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        پیام درون برنامه ای اعطای وام به دیگر اعضا
                    </p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('sendPushNotificationToOthers')
                        }
                        checked={checked.sendPushNotificationToOthers}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، درصورت اعطای...
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        ارسال نوتیفیکشن اعطای وام به تمامی اعضا
                    </p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked(
                                'sendPushNotificationToAllMembers'
                            )
                        }
                        checked={checked.sendPushNotificationToAllMembers}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، در صورت اعطای وام، پیام درون برنامه
                    ای برای تمامی اعضای صندوق ارسال خواهد شد که شامل مبلغ وام و
                    نام وام گیرنده است.
                </p>
                <hr className=" my-2" />
                <p className=" text-lg my-2 px-2">دوره‌ی گزارش وام‌ها</p>
                <div className="flex justify-center mx-2 my-4">
                    <div className=" w-full bg-[#E6F3DD] rounded-full px-1 py-1 text-center flex justify-between">
                        <p
                            className={classNames(
                                ' w-full py-2 rounded-2xl transition ease-in-out delay-150 cursor-pointer',
                                digestInterval === 'wkl'
                                    ? ' bg-green-1 text-white'
                                    : ' text-green-1'
                            )}
                            onClick={() => setDigestInterval('wkl')}
                        >
                            هفتگی
                        </p>
                        <p
                            className={classNames(
                                ' w-full py-2 rounded-2xl transition ease-in-out delay-150 cursor-pointer',
                                digestInterval === 'mnt'
                                    ? ' bg-green-1 text-white'
                                    : ' text-green-1'
                            )}
                            onClick={() => setDigestInterval('mnt')}
                        >
                            ماهانه
                        </p>
                    </div>
                </div>
                <p className=" my-3 px-2 text-sm">
                    گزارش وام‌های صندوق در حالت هفتگی جمعه‌ها و در حالت ماهانه
                    اول هر ماه ارسال می‌شود. این انتخاب روی هر سه کانال بالا —
                    پیامک، نوتیفیکیشن و پیام درون برنامه‌ای — اعمال می‌شود. در
                    هفته یا ماهی که وامی پرداخت نشده باشد، گزارشی ارسال نمی‌شود.
                </p>
            </div>
            <div className=" grow-0">
                <div className=" bg-white py-4 px-4">
                    <button
                        className=" w-full bg-green-1 rounded-2xl text-white py-3"
                        onClick={() => {
                            const payload: ISettingSMSPayload = {
                                moneyPool: id,
                                sms_others_define_loan:
                                    checked.sendMessageLoanToOthers,
                                sms_pay_portion_reminder:
                                    checked.sendMessageRememberMemberShip,
                                sms_pay_installment_reminder:
                                    checked.sendMessageRememberLoan,
                                sms_inform_managers_of_cashins:
                                    checked.sendMessageDepositToManager,
                                message_others_loan:
                                    checked.sendPushNotificationToOthers,
                                notif_others_loan:
                                    checked.sendPushNotificationToAllMembers,
                                loan_digest_interval: digestInterval,
                            }
                            mutate(payload)
                        }}
                    >
                        ثبت تغییرات
                    </button>
                </div>
            </div>
            <BuyPlanModal
                show={isOpenModal}
                onHide={() => setIsOpenModal(false)}
                title="برای اطلاع رسانی از پیامک رایگان، صندوق خود را ارتقاء دهید."
            />
        </div>
    )
}
